module.exports = __webpack_public_path__ + "chris-dd8efab8298f4a10f1647a7d1df4ffdf.png";